<template>
    <div>
        <CHeading :variant="2">
            <template v-if="isWorkingGroup"> O&nbsp;ambasádorovi/ke </template>
            <template v-else> O&nbsp;autorovi </template>
        </CHeading>
        <CCardBox>
            <div v-if="skill.author || authorProfile" class="flex items-start gap-4">
                <div v-if="!skill.author" class="shrink-0">
                    <UserProfileCircle class="size-16" :custom-profile="authorProfile" />
                </div>
                <div v-else class="flex-1">
                    <IconTextRow class="mb-3" icon="personal" variant="default">
                        <strong class="font-semibold">{{ skill.author || authorProfile }}</strong>
                    </IconTextRow>
                    <div v-if="authorBio" v-html="authorBio" class="text-sm"></div>
                </div>
            </div>
        </CCardBox>
    </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import { computed, ref, onMounted } from 'vue'

import { Skill, SkillType } from '#shared/types/Skill'
import type { UserProfile } from '#shared/types/User'
import { getFullName } from '#shared/utils'
import IconTextRow from '@/components/common/IconTextRow.vue'
import UserProfileCircle from '@/components/common/UserProfileCircle.vue'
import CCardBox from '@/components/ui/CCardBox.vue'
import CHeading from '@/components/ui/CHeading.vue'
import { useUser } from '@/composables/user/useUser'

const props = defineProps({
    skill: {
        type: Object as PropType<Skill>,
        required: true
    }
})

const { loadUserProfile } = useUser()
const authorProfile = ref<UserProfile | null>(null)

const isWorkingGroup = computed(() => {
    return props.skill.type === SkillType.workgroup
})

const authorName = computed(() => {
    if (authorProfile.value) {
        return getFullName(authorProfile.value)
    }
    return props.skill.author
})

const authorBio = computed(() => {
    // Prioritize skill's authorBio over profile's shortProfile
    return props.skill.authorBio || authorProfile.value?.shortProfile
})

// Load author profile if we have createdById
onMounted(async () => {
    if (props.skill.createdById) {
        try {
            authorProfile.value = await loadUserProfile(props.skill.createdById)
        } catch (error) {
            console.warn('Failed to load author profile:', error)
            // Fall back to skill.author and skill.authorBio
        }
    }
})
</script>